// Elección del código correcto cuando la cámara ve más de uno en el mismo
// cuadro. El sticker de VAISAND lleva dos: el VIN de 17 caracteres (el que
// queremos) y otro de 13 debajo. En vez de recortar la zona de detección o
// pedirle al operario que elija, se descarta por patrón y el bucle sigue
// buscando hasta encontrar el que cumple.
//
// Vive aparte del hook a propósito: es la única lógica real de la lectura, y
// aislada se prueba sin cámara ni DOM.

// Formatos 1D que puede llevar el sticker (VIN + el código secundario).
// Compartido entre la vía en vivo (BarcodeDetector/ZXing) y la vía foto
// (ZXing puro) para no listar los mismos códigos dos veces.
export const FORMATOS_1D = ['code_128', 'code_39', 'ean_13', 'ean_8', 'upc_a', 'upc_e', 'itf'];

// Un patrón mal escrito en un .env no puede tumbar la vista de Calidad, así que
// un regex inválido degrada a "aceptar cualquier código" en lugar de reventar.
export function compilarPatron(patron) {
    if (typeof patron !== 'string') return null;
    const limpio = patron.trim();
    if (!limpio) return null;
    try {
        return new RegExp(limpio);
    } catch (e) {
        console.error(`REACT_APP_CALIDAD_SERIE_PATTERN no es un regex válido: ${limpio}`);
        return null;
    }
}

// Misma normalización que usa CalidadContext para contar unidades por serie,
// para que lo leído y lo tecleado se comparen igual.
export function normalizar(codigo) {
    return typeof codigo === 'string' ? codigo.trim().toUpperCase() : '';
}

export function elegirCodigo(codigos, patron) {
    if (!Array.isArray(codigos)) return null;
    for (const bruto of codigos) {
        const codigo = normalizar(bruto);
        if (!codigo) continue;
        if (!patron || patron.test(codigo)) return codigo;
    }
    return null;
}
